(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-collapsible"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.dataset.faqReady) return;
      root.dataset.faqReady = 'true';
      if (root.dataset.singleOpen !== 'true') return;
      var items = root.querySelectorAll('details.faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    }
    function initAll() {
      document.querySelectorAll('[data-faq]').forEach(initFaq);
    }
    initAll();
    // Re-run when sections are added/reloaded in the theme editor
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
